<script>
import { HeartIcon, CurrencyDollarIcon, EnvelopeIcon } from '@heroicons/vue/24/outline'
import { Duration, DateTime } from 'luxon'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TeamRaisedAmount from '@/components/fundraisers/teams/team-raised-amount.vue'
import TeamActions from '@/components/fundraisers/public/teams/team-actions.vue'
export default {
  name: 'FundraiserTeamRightColumn',
  components: { TeamActions, TeamRaisedAmount, TwButton, DonationsListGroup, TwTimeLeft, TwProgressBar, HeartIcon, CurrencyDollarIcon },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showElement: false,
    };
  },
  computed: {
    fundraiserDeadlineDays () {
      const color = '#f3f3f4'
      return Math.round(DateTime.fromISO(this.fundraiser.deadline).diffNow('days').days)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 600) { // Adjust scroll threshold as needed
        this.showElement = true;
      } else {
        this.showElement = false;
      }
    },
  },
}
</script>

<template>
  <div class="lg:rounded-2xl lg:shadow-sm lg:bg-white p-0 lg:p-6">
    <div v-if="team.cached" class="mb-2">
      <team-raised-amount :team="team" />
      <tw-progress-bar :progress="team.cached.percentage_raised" />
      <tw-time-left class=" text-gray-600 text-sm" :deadline="fundraiser.deadline" detailed />
      <team-actions :fundraiser="fundraiser" :team="team" />
    </div>

    <donations-list-group :fundraiser="fundraiser" :team="team" class="my-8 hidden lg:block" />
    <div class="hidden lg:static">
      <div v-if="fundraiser.cached" class="uppercase">
        <heart-icon class="h-4 inline" /> Organizer: {{ fundraiser.cached.organizer_name }}
      </div>
      <div v-if="fundraiser.cached" class="uppercase">
        <currency-dollar-icon class="h-4 inline" /> Beneficiary: {{ fundraiser.cached.beneficiary_name }}
      </div>
    </div>
    <div v-show="showElement" class="mobile-donation-box border border-gray-100 shadow-md rounded-2xl bg-white p-4 lg:hidden">
      <div v-if="fundraiser.cached">
        <team-raised-amount :team="team" />
        <tw-progress-bar :progress="fundraiser.cached.percentage_raised" />
        <tw-button :to="{name: 'TeamDonatePage', params:{ teamId: team.id }}" block size="lg" class="w-full mt-4" variant="amber">
          Donate
        </tw-button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
